import {Component, Inject, OnInit, OnDestroy} from '@angular/core';
import {NotificationService} from 'src/app/core/services/notification.service';
import {Message} from 'src/app/core/class/message';
import {MAT_DIALOG_DATA, MatDialog, MatDialogRef} from '@angular/material/dialog';
import {WarningComponent} from 'src/app/shared/components/warning/warning.component';
import { DocumentService } from 'src/app/core/services/document.service';
import { EnumCustomerProcessingStatus } from 'src/app/core/constants/contract';
import { ToastrService } from 'ngx-toastr';
import { SmsResultDialogComponent } from '../sms-result-dialog/sms-result-dialog.component';

@Component({
  selector: 'app-resend-contract-dialog',
  templateUrl: './resend-contract-dialog.component.html',
  styleUrls: ['./resend-contract-dialog.component.scss']
})
export class ResendContractDialogComponent implements OnInit, OnDestroy {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    public dialogRef: MatDialogRef<ResendContractDialogComponent>,
    private dialog: MatDialog,
    public notificationService: NotificationService,
    private message: Message,
    private documentService: DocumentService,
    private toastr: ToastrService,
  ) {
    dialogRef.disableClose = false;
  }
  isFormChanging: boolean;
  dataSource: any;
  dataSelected: Map<any, Document> = new Map<any, Document>();
  checkAll: boolean;
  enumCustomerProcessingStatus = EnumCustomerProcessingStatus;
  sendEmail = true;

  public displayedColumns = [
    'check',
    'userName',
    'status',
    'method'
  ];

  ngOnInit() {
    this.notificationService.subscribeErrorService();
    this.getCustomerProcessing();
  }

  getCustomerProcessing() {
    this.dataSource = this.data.dataSource
  }

  ngOnDestroy() {
    this.notificationService.unsubscribeErrorService();
  }

  onNoClick() {
    if (this.isFormChanging) {
      const dialogRe = this.dialog.open(WarningComponent, {
        width: '30%',
        data: this.message.getMessage('messages.confirm_change_data')
      });

      dialogRe.afterClosed().subscribe(rs => {
        if (rs) {
          this.dialogRef.close();
        }
        dialogRe.close();
      });
    } else {
      this.dialogRef.close();
    }
  }

  onClickBtnConfirm() {
    this.documentService.reSendLinkUserSignContract(this.data.contractId, Array.from(this.dataSelected.values())).subscribe(res => {
      if (!res.success) {
        this.toastr.error(res.message);
      } else {
        if (res.data && res.data.length > 0) {
          const dialogRe = this.dialog.open(SmsResultDialogComponent, {
            width: this.data.width,
            maxWidth: this.data.maxWidth,
            data: {
              document: this.data.document,
              smsResult: res.data
            }
          });
          this.dialogRef.close();
          return;
        }
        
        this.dialogRef.close(res.success);
      }
    });
  }

  checkAllCheckBox() {
    this.dataSource.forEach(data => {
      data.checked = this.checkAll;
      if (data.checked) {
        this.dataSelected.set(data.id, data);
      } else {
        this.checkAll = false;
        this.dataSelected.delete(data.id);
      }
    })
  }

  public onSelect(element) {
    if (this.dataSource == null
      || this.dataSource.length === 0) {
      return;
    }
    if (element.checked) {
      this.dataSelected.set(element.id, element);
    } else {
      this.dataSelected.delete(element.id);
    }

    this.checkCheckAll();
  }

  checkCheckAll() {
    if (this.dataSelected.size === 0) {
      this.checkAll = false;
      return;
    }
    if (this.dataSelected.size === this.dataSource.length) {
      this.checkAll = true;
      return;
    }
  }

}
